// extracted by mini-css-extract-plugin
export default {"logo":"ErrorPage__logo___uINgq","logoIcon":"ErrorPage__logoIcon___fBMjE","container":"ErrorPage__container____apya","message":"ErrorPage__message___qMkfb"};